// Firestore REST API values → plain JS, the shape doc.data() returns.
// (scripts/export-learner-data.mjs carries a copy: it runs under plain Node.)

export function decodeValue(v) {
  if (!v || typeof v !== 'object') return null;
  if ('nullValue' in v) return null;
  if ('booleanValue' in v) return v.booleanValue;
  if ('integerValue' in v) return Number(v.integerValue);
  if ('doubleValue' in v) return Number(v.doubleValue);
  if ('stringValue' in v) return v.stringValue;
  if ('timestampValue' in v) return v.timestampValue;
  if ('referenceValue' in v) return v.referenceValue;
  if ('arrayValue' in v) return (v.arrayValue.values || []).map(decodeValue);
  if ('mapValue' in v) return decodeFields(v.mapValue.fields);
  return null;
}

export function decodeFields(fields = {}) {
  return Object.fromEntries(Object.entries(fields).map(([k, v]) => [k, decodeValue(v)]));
}

// A REST document → { id, ...fields }, like { id: d.id, ...d.data() }.
export function decodeDocument(doc) {
  return { id: doc.name.split('/').pop(), ...decodeFields(doc.fields) };
}
